import { IGeoState } from '../../types/redux/geo';
import { TReduxActions } from '../../types/redux';
import { EGeoActions } from '../../constants/actionTypes/geo';

export const defaultState: IGeoState = {
  locationsMap: {},
};

export const geoReducer = (state: IGeoState = defaultState, action: TReduxActions): IGeoState => {
  switch (action.type) {
    case EGeoActions.REMEMBER_LOCATION:
      return {
        ...state,
        locationsMap: action.payload,
      };
    case EGeoActions.GET_LOCATIONS_REQUEST_START:
      return {
        ...state,
        isFetching: true,
        isError: false,
      };
    case EGeoActions.GET_LOCATIONS_REQUEST_ERROR:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    case EGeoActions.GET_LOCATIONS_REQUEST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        locations: action.payload,
      };
    default:
      return state;
  }
};
